<template>
  <div class="form tab-content">
    <v-expansion-panels>
      <v-expansion-panel id="accessories-panel" style="margin: 0 20px;">
        <v-expansion-panel-header>
          <div>{{ $t("Included") }}</div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-card style="box-shadow: none">
            <accessories-and-others-list
              :accessories-selected="accessoriesSelectedByMaterialId"
              :disabled="disabled"
              :can-change-accessory="false"
            />
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
      <v-expansion-panel id="accessories-panel">
        <v-expansion-panel-header>
          <div>{{ $t("ToInclude") }}</div>
        </v-expansion-panel-header>
        <v-expansion-panel-content>
          <v-card style="box-shadow: none">
            <accessories-and-others-list
              v-if="currentAction === 'list'"
              :key="updated"
              :accessories-selected="accessories"
              :disabled="disabled"
              @addAccessory="addAccessoriesForm($event)"
              @edit-item="addAccessoriesForm('edit', $event)"
              @delete-item="deleteRequestField($event)"
            />

            <accessories-and-others-form
              v-if="currentAction !== 'list' && !disabled"
              :relation-family-id-select="relationFamilyIdSelect"
              :family-id="familyId"
              :selected-fields="accessories"
              :current-action="currentAction"
              :original-item="requestFieldForm.data"
              @add="addRequestField"
              @edit="editRequestField"
              @close="closeAddAccessoriesForm"
            />
          </v-card>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>
  </div>
</template>

<script>
import AccessoriesAndOthersList from "@/components/Home/Forms/_SpecialTabs/AccessoriesAndOthers/AccessoriesAndOthersList";
import AccessoriesAndOthersForm from "@/components/Home/Forms/_SpecialTabs/AccessoriesAndOthers/AccessoriesAndOthersForm";
export default {
  name: "AccessoriesAndOthersTab",
  components: { AccessoriesAndOthersForm, AccessoriesAndOthersList },

  props: {
    accessoriesSelected: Array,
    accessoriesSelectedByMaterialId: Array,

    familyId: {
      type: String,
      required: true
    },

    relationFamilyIdSelect: String,

    disabled: {
      type: Boolean,
      default: false
    }
  },

  data() {
    return {
      currentAction: "list",
      accessories: [],

      requestFieldForm: {
        index: -1,
        data: {}
      },

      updated: 0,

      openPanel: null
    };
  },

  watch: {
    accessoriesSelected(value) {
      this.accessories = value;
    }
  },

  mounted() {
    this.accessories = this.accessoriesSelected;
  },

  methods: {
    addAccessoriesForm(currentAction, index = null) {
      if (index !== null && index > -1) {
        this.requestFieldForm.data = this.accessories[index];
        this.requestFieldForm.index = index;
      }
      this.currentAction = currentAction;
    },

    deleteRequestField(index) {
      this.accessories.splice(index, 1);
    },

    closeAddAccessoriesForm() {
      this.currentAction = "list";
      this.requestFieldForm.data = {};
      this.requestFieldForm.index = -1;
    },

    addRequestField(newRequestField) {
      this.accessories.push(newRequestField);
      this.closeAddAccessoriesForm();
    },

    editRequestField(updatedRequestField) {
      this.accessories[this.requestFieldForm.index] = updatedRequestField;

      this.closeAddAccessoriesForm();
      this.updated++;
    }
  }
};
</script>

<style>
#accessories-panel .v-expansion-panel-header {
  padding: 12px 24px;
  min-height: 48px;
  font-size: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Forms/_SpecialTabs/AccessoriesAndOthers/AccessoriesAndOthersTab.vue